'use client'

import { useState } from 'react'
import { sendRequest } from '@/utils/request'
import { toast } from '@/lib/toast'
import { validatePassword, getPasswordError, type PasswordChecks } from '@/utils/auth'

export function useChangePassword() {
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('')
  const [isPasswordLoading, setIsPasswordLoading] = useState(false)

  const checks: PasswordChecks = validatePassword(newPassword)

  const handlePasswordChange = async () => {
    const err = getPasswordError(newPassword, newPasswordConfirm)
    if (err) return toast.error(err)
    setIsPasswordLoading(true)
    const res = await sendRequest({ url: `/customer/password`, method: 'PUT', body: { password: newPassword } })
    setIsPasswordLoading(false)
    if (!res) return toast.error('Нууц үгийг хадгалахад алдаа гарлаа')
    if (res.error) return toast.error(res.error)
    toast.success('Нууц үгийг амжилттай хадгаллаа')
    setNewPassword('')
    setNewPasswordConfirm('')
  }

  return {
    newPassword, setNewPassword,
    newPasswordConfirm, setNewPasswordConfirm,
    checks,
    isPasswordLoading,
    handlePasswordChange,
  }
}
